import React, { useState, useEffect, useRef } from "react";
import Header from "../../../Components/Header/Header";
import LeftMenu from "../../../Components/LeftMenu/LeftMenu";
import TopMenu from "../../Airline/common/TopMenu";
import AssetsIcon from "../../../assets/images/assets.svg";
import OperationIcon from "../../../assets/images/oparation.svg";
import OnAirIcon from "../../../assets/images/onair.svg";
import RepairIcon from "../../../assets/images/repair.svg";
import OnLoanIcon from "../../../assets/images/onloan.svg";
import AssetsIconA from "../../../assets/images/assets_a.svg";
import OperationIconA from "../../../assets/images/oparation_a.svg";
import OnAirIconA from "../../../assets/images/onair_a.svg";
import RepairIconA from "../../../assets/images/repair_a.svg";
import OnLoanIconA from "../../../assets/images/onloan_a.svg";
import Uldbg from "../../../assets/images/uldbg.png";

import ChartDown from "../../../assets/images/chart_download.png";
import Filter from "../../../assets/images/filter_new.png";
import Zoom from "../../../assets/images/zoom.png";

import $ from "jquery";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter, faMaximize, faFileArrowDown } from '@fortawesome/free-solid-svg-icons';
import Export from "../../../assets/images/export.svg";
import Button from 'react-bootstrap/Button';

import "jqwidgets-scripts/jqwidgets/styles/jqx.base.css";
import "jqwidgets-scripts/jqwidgets/jqxcore";
import "jqwidgets-scripts/jqwidgets/jqxcore";
import "jqwidgets-scripts/jqwidgets/jqxdata";
import "jqwidgets-scripts/jqwidgets/jqxheatmap";
import Form from "react-bootstrap/Form";
import Select from "react-select";


import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import ApexCharts from 'react-apexcharts';

import ChartDataLabels from "chartjs-plugin-datalabels";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title, CategoryScale, LinearScale, BarElement, } from "chart.js";
import { Doughnut, Bar } from "react-chartjs-2";
import { withRFSToken } from "../../../Services/axios";
import { CHARTCOND, CHARTLOANAGENTS, CHARTOWNER, CHARTOWNERTABLE, CHARTSTATION, CHARTSTATUS, CHARTSTNCOND, CHARTTABLE, CHARTTYPECOND, CHARTULD, CHARTYPE, GETCONDITIONCODE, GETDESTINATION, GETOWNERCODE, GETTYPECODE, } from "../../../Utils/conts";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom/cjs/react-router-dom";

ChartJS.register(
    ArcElement,
    Tooltip,
    Legend,
    Title,
    CategoryScale,
    LinearScale,
    BarElement,
    ChartDataLabels
);

const Charts = () => {
    const [isLoading, setIsLoading] = useState(true);
    const initialTab = "general";
    const [selectedButton, setSelectedButton] = useState(initialTab);

    const handleButtonClick = (button) => {
        setSelectedButton(button);
        // localStorage.setItem('tab', button);
    };

    const isMounted = useRef(false);
    const [uldCount, setUldCount] = useState(0);
    const [getTypeCodes, setGetTypeCodes] = useState([]);
    const [getOwnerCodes, setGetOwnerCode] = useState([]);
    const [getAirlineName, setGetAirlineName] = useState([]);
    const [getStation, setGetStation] = useState([]);
    const [isFilter, setIsFilter] = useState(false);
    // const [getStationArr, setGetStationArr] = useState([]);
    // const [countsArr, setCountsArr] = useState([]);
    const [matrixData, setMatrixData] = useState([]);
    const [matrixOwnerData, setMatrixOwnerData] = useState([]);
    // const [getUldData, setGetUldData] = useState([]);
    // const [getUldLabel, setGetUldLabel] = useState([]);
    // const [getStationData, setGetStationData] = useState([]);
    // const [getStationLabel, setGetStationLabel] = useState([]);
    const statusDropOptions = [
        { value: '1', label: 'In Operation' },
        { value: '3', label: 'In Reserve' },
        { value: '4', label: 'On Air' },
        { value: '2', label: 'Repair' },
        { value: '5', label: 'On Loan' },
    ];
    const conDropOPtions = [
        { value: 'SER', label: 'Serviceable' },
        { value: 'DAM', label: 'Damaged' },
        { value: 'DIS', label: 'Discarded' },
    ]

    const [formData, setFormData] = useState({
        type_code: [],
        owner_code: [],
        condition_code: [],
        status: [],
        station_code: [],
    });

    const [condOptions, setCondOptions] = useState({
        chart: {
            type: 'bar',
            height: 350,
            toolbar: {
                show: false // This will hide the toolbar
            }
        },
        plotOptions: {
            bar: {
                horizontal: true,
                columnWidth: '5%',
                endingShape: 'rounded',
                borderRadius: 4,
                borderRadiusApplication: 'end',
                borderRadiusWhenStacked: 'last',
                dataLabels: {
                    position: 'top', // top, center, bottom
                },
            }
        },
        dataLabels: {
            enabled: true,
            offsetY: 0,
            offsetX: 35,
            formatter: (val) => {
                return val;
            },
            style: {
                fontSize: '12px',
                colors: ["#304758"]
            }
        },
        stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
        },
        xaxis: {
            categories: ['Servicable', 'Damage',]
        },
        yaxis: {
            title: {
                text: ' '
            },
            labels: {
                style: {
                    fontSize: '12',
                    colors: ["#000"],
                    fontWeight: 600,
                }
            }
        },
        fill: {
            opacity: 1,
            colors: [
                "rgba(255, 181, 95, 1)",
                "rgba(203, 140, 255, 1)",
                "rgba(99, 169, 255, 1)",
                'rgba(84, 202, 82, 1)',
                'rgba(255, 107, 107, 1)',
            ]
        },
        tooltip: {
            y: {
                formatter: function (val) {
                    return val + " units";
                }
            }
        }
    });

    const [condSeries, setCondSeries] = useState([
        {
            name: 'ULD',
            data: [] // [44, 55, 57, 56, 61, 58, 63, 60, 66, 75, 80, 90]
        },
    ]);

    const [chartTypeOptions, setChartTypeOptions] = useState({
        chart: {
            type: 'bar',
            height: 450,
            toolbar: {
                show: false // This will hide the toolbar
            },
            background: 'transparent',

            zoom: {
                enabled: false
            }
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '55%',
                endingShape: 'rounded',
                borderRadius: 4,
                borderRadiusApplication: 'end',
                borderRadiusWhenStacked: 'last',
                dataLabels: {
                    position: 'top', // top, center, bottom
                },
            }
        },
        dataLabels: {
            enabled: true,
            offsetY: -20,
            formatter: (val) => {
                return val;
            },
            style: {
                fontSize: '13px',
                colors: ["#000"]
            }
        },
        stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
        },
        xaxis: {
            categories: [],// ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            tickPlacement: "on",
            labels: {
                style: {
                    fontSize: '12',
                    colors: ["#000"],
                    fontWeight: 600,
                }
            }
        },
        yaxis: {
            // min: 0,
            // max: 3000,
            // tickAmount: 6,
            // stepSize: 5,
            title: {
                text: ''
            },
            labels: {
                style: {
                    fontSize: '12',
                    colors: ["#000"],
                    fontWeight: 600,
                },
                // formatter: (val) => {
                //     if (val === 10 || val === 50 || val === 100 || val === 500 || val === 1000 || val === 2000) {
                //         return val;
                //     } else {
                //         return '';  // Return an empty string for other ticks to hide them
                //     }
                // }
            }
        },
        grid: {
            show: true,
            borderColor: '#e7e7e7',
            strokeDashArray: 4,
            xaxis: {
                lines: {
                    show: false
                }
            },
            yaxis: {
                lines: {
                    show: true
                }
            },
            background: 'transparent', // Ensure the grid background is transparent
        },
        legend: {
            show: true,
            position: 'bottom',

        },
        fill: {
            opacity: 1,
            colors: ["rgba(54, 162, 235, 1)"]
        },
        tooltip: {
            y: {
                formatter: function (val) {
                    return val + " units";
                }
            }
        }
    });

    const [chartTypeSeries, setChartTypeSeries] = useState([
        {
            name: 'Units Sold',
            data: [] // [44, 55, 57, 56, 61, 58, 63, 60, 66, 75, 80, 90]
        },
    ]);

    const [chartLoanTypeOptions, setChartLoanTypeOptions] = useState({
        chart: {
            type: 'bar',
            height: 450,
            toolbar: {
                show: false // This will hide the toolbar
            },
            background: 'transparent',

            zoom: {
                enabled: false,
            }
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '55%',
                endingShape: 'rounded',
                borderRadius: 4,
                borderRadiusApplication: 'end',
                borderRadiusWhenStacked: 'last',
                dataLabels: {
                    position: 'top', // top, center, bottom
                },
            }
        },
        dataLabels: {
            enabled: true,
            offsetY: -20,
            formatter: (val) => {
                return val;
            },
            style: {
                fontSize: '13px',
                colors: ["#000"]
            }
        },
        stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
        },
        xaxis: {
            categories: [],// ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            tickPlacement: "on",
            labels: {
                style: {
                    fontSize: '12',
                    colors: ["#000"],
                    fontWeight: 600,
                }
            }
        },
        yaxis: {
            // min: 0,
            // max: 3000,
            // tickAmount: 6,
            // stepSize: 5,
            title: {
                text: ''
            },
            labels: {
                style: {
                    fontSize: '12',
                    colors: ["#000"],
                    fontWeight: 600,
                },
                // formatter: (val) => {
                //     if (val === 10 || val === 50 || val === 100 || val === 500 || val === 1000 || val === 2000) {
                //         return val;
                //     } else {
                //         return '';  // Return an empty string for other ticks to hide them
                //     }
                // }
            }
        },
        grid: {
            show: true,
            borderColor: '#e7e7e7',
            strokeDashArray: 4,
            xaxis: {
                lines: {
                    show: false
                }
            },
            yaxis: {
                lines: {
                    show: true
                }
            },
            background: 'transparent', // Ensure the grid background is transparent
        },
        legend: {
            show: true,
            position: 'bottom',

        },
        fill: {
            opacity: 1,
            colors: ["rgba(54, 162, 235, 1)"]
        },
        tooltip: {
            y: {
                formatter: function (val) {
                    return val + " units";
                }
            }
        }
    });

    const [chartLoanTypeSeries, setChartLoanTypeSeries] = useState([
        {
            name: 'Units Sold',
            data: [] // [44, 55, 57, 56, 61, 58, 63, 60, 66, 75, 80, 90]
        },
    ]);

    const [chartOwnerOptions, setChartOwnerOptions] = useState({
        chart: {
            type: 'bar',
            height: 450,
            toolbar: {
                show: false // This will hide the toolbar
            },
            zoom: {
                enabled: false
            }
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '55%',
                endingShape: 'rounded',
                borderRadius: 4,
                borderRadiusApplication: 'end',
                borderRadiusWhenStacked: 'last',
                dataLabels: {
                    position: 'top', // top, center, bottom
                },
            }
        },
        dataLabels: {
            enabled: true,
            offsetY: -20,
            formatter: (val) => {
                return val;
            },
            style: {
                fontSize: '13px',
                colors: ["#000"]
            }
        },
        stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
        },
        xaxis: {
            categories: [],// ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            tickPlacement: "on",
            labels: {
                style: {
                    fontSize: '12',
                    colors: ["#000"],
                    fontWeight: 600,
                }
            }
        },
        yaxis: {
            // min: 0,
            // max: 100,
            // stepSize: 5,
            title: {
                text: ''
            },
            labels: {
                style: {
                    fontSize: '12',
                    colors: ["#000"],
                    fontWeight: 600,
                }
            }
        },
        legend: {
            show: true,
            position: 'bottom',

        },
        fill: {
            opacity: 1,
            colors: ["rgba(54, 162, 235, 1)"]
        },
        tooltip: {
            y: {
                formatter: function (val) {
                    return val + " units";
                }
            }
        }
    });

    const [chartOwnerSeries, setChartOwnerSeries] = useState([
        {
            name: 'Units Sold',
            data: [] // [44, 55, 57, 56, 61, 58, 63, 60, 66, 75, 80, 90]
        },
    ]);

    const [chartLoanOwnerOptions, setChartLoanOwnerOptions] = useState({
        chart: {
            type: 'bar',
            height: 450,
            toolbar: {
                show: false // This will hide the toolbar
            },
            zoom: {
                enabled: false
            }
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '55%',
                endingShape: 'rounded',
                borderRadius: 4,
                borderRadiusApplication: 'end',
                borderRadiusWhenStacked: 'last',
                dataLabels: {
                    position: 'top', // top, center, bottom
                },
            }
        },
        dataLabels: {
            enabled: true,
            offsetY: -20,
            formatter: (val) => {
                return val;
            },
            style: {
                fontSize: '13px',
                colors: ["#000"]
            }
        },
        stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
        },
        xaxis: {
            categories: [],// ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            tickPlacement: "on",
            labels: {
                style: {
                    fontSize: '12',
                    colors: ["#000"],
                    fontWeight: 600,
                }
            }
        },
        yaxis: {
            // min: 0,
            // max: 100,
            // stepSize: 5,
            title: {
                text: ''
            },
            labels: {
                style: {
                    fontSize: '12',
                    colors: ["#000"],
                    fontWeight: 600,
                }
            }
        },
        legend: {
            show: true,
            position: 'bottom',

        },
        fill: {
            opacity: 1,
            colors: ["rgba(54, 162, 235, 1)"]
        },
        tooltip: {
            y: {
                formatter: function (val) {
                    return val + " units";
                }
            }
        }
    });

    const [chartLoanOwnerSeries, setChartLoanOwnerSeries] = useState([
        {
            name: 'Units Sold',
            data: [] // [44, 55, 57, 56, 61, 58, 63, 60, 66, 75, 80, 90]
        },
    ]);

    const [stationOptions, setStationOptions] = useState({
        chart: {
            type: 'bar',
            height: 350,
            toolbar: {
                show: false // This will hide the toolbar
            }
        },
        plotOptions: {
            bar: {
                horizontal: true,
                columnWidth: '5%',
                barHeight: '40%',
                endingShape: 'rounded',
                borderRadius: 4,
                borderRadiusApplication: 'end',
                borderRadiusWhenStacked: 'last',
                dataLabels: {
                    position: 'top', // top, center, bottom
                },
            }
        },
        dataLabels: {
            enabled: true,
            offsetY: 0,
            offsetX: 25,
            formatter: (val) => {
                return val;
            },
            style: {
                fontSize: '12px',
                colors: ["#304758"]
            }
        },
        stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
        },
        xaxis: {
            categories: [],

        },
        yaxis: {
            title: {
                text: ' '
            },
            labels: {
                offsetY: 2,
                style: {
                    fontSize: '12',
                    colors: ["#000"],
                    fontWeight: 600,
                }
            }
        },
        fill: {
            opacity: 1,
            colors: ["rgba(54, 162, 235, 1)"]
        },
        tooltip: {
            y: {
                formatter: function (val) {
                    return val + " units";
                }
            }
        }
    });

    const [stationSeries, setStationSeries] = useState([
        {
            name: 'ULD',
            data: [] // [44, 55, 57, 56, 61, 58, 63, 60, 66, 75, 80, 90]
        },
    ]);

    const [loanStationOptions, setLoanStationOptions] = useState({
        chart: {
            type: 'bar',
            height: 450,
            toolbar: {
                show: false // This will hide the toolbar
            },
            zoom: {
                enabled: false
            }
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '55%',
                endingShape: 'rounded',
                borderRadius: 4,
                borderRadiusApplication: 'end',
                borderRadiusWhenStacked: 'last',
                dataLabels: {
                    position: 'top', // top, center, bottom
                },
            }
        },
        dataLabels: {
            enabled: true,
            offsetY: -20,
            formatter: (val) => {
                return val;
            },
            style: {
                fontSize: '13px',
                colors: ["#000"]
            }
        },
        stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
        },
        xaxis: {
            categories: [],// ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            tickPlacement: "on",
            labels: {
                style: {
                    fontSize: '12',
                    colors: ["#000"],
                    fontWeight: 600,
                }
            }
        },
        yaxis: {
            // min: 0,
            // max: 100,
            // stepSize: 5,
            title: {
                text: ''
            },
            labels: {
                style: {
                    fontSize: '12',
                    colors: ["#000"],
                    fontWeight: 600,
                }
            }
        },
        legend: {
            show: true,
            position: 'bottom',

        },
        fill: {
            opacity: 1,
            colors: ["rgba(54, 162, 235, 1)"]
        },
        tooltip: {
            y: {
                formatter: function (val) {
                    return val + " units";
                }
            }
        }
    });

    const [loanStationSeries, setLoanStationSeries] = useState([
        {
            name: 'ULD',
            data: [] // [44, 55, 57, 56, 61, 58, 63, 60, 66, 75, 80, 90]
        },
    ]);
    const [loanAgentOptions, setLoanAgentOptions] = useState({
        chart: {
            type: 'bar',
            height: 350,
            toolbar: {
                show: false // This will hide the toolbar
            }
        },
        plotOptions: {
            bar: {
                horizontal: true,
                columnWidth: '5%',
                barHeight: '40%',
                endingShape: 'rounded',
                borderRadius: 4,
                borderRadiusApplication: 'end',
                borderRadiusWhenStacked: 'last',
                dataLabels: {
                    position: 'top', // top, center, bottom
                },
            }
        },
        dataLabels: {
            enabled: true,
            offsetY: 0,
            offsetX: 25,
            formatter: (val) => {
                return val;
            },
            style: {
                fontSize: '12px',
                colors: ["#304758"]
            }
        },
        stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
        },
        xaxis: {
            categories: [],

        },
        yaxis: {
            title: {
                text: ' '
            },
            labels: {
                offsetY: -10,
                style: {
                    fontSize: '12',
                    colors: ["#000"],
                    fontWeight: 600,
                }
            }
        },
        fill: {
            opacity: 1,
            colors: ["rgba(54, 162, 235, 1)"]
        },
        tooltip: {
            y: {
                formatter: function (val) {
                    return val + " units";
                }
            }
        }
    });

    const [loanAgentSeries, setLoanAgentSeries] = useState([
        {
            name: 'ULD',
            data: [] // [44, 55, 57, 56, 61, 58, 63, 60, 66, 75, 80, 90]
        },
    ]);

    const [statusOptions, setStatusOptions] = useState({
        chart: {
            type: 'bar',
            height: 350,
            toolbar: {
                show: false // This will hide the toolbar
            }
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '55%',
                endingShape: 'rounded',
                borderRadius: 4,
                borderRadiusApplication: 'end',
                borderRadiusWhenStacked: 'last',
                dataLabels: {
                    position: 'top', // top, center, bottom
                },
            }
        },
        dataLabels: {
            enabled: true,
            offsetY: -20,
            formatter: (val) => {
                return val;
            },
            style: {
                fontSize: '12px',
                colors: ["#304758"]
            }
        },
        stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
        },
        xaxis: {
            categories: [],
            labels: {
                style: {
                    fontSize: '12',
                    colors: ["#000"],
                    fontWeight: 600,
                }
            }
        },
        yaxis: {
            title: {
                text: ' '
            }
        },
        fill: {
            opacity: 1,
            colors: [
                "rgba(255, 181, 95, 1)",
                "rgba(203, 140, 255, 1)",
                "rgba(99, 169, 255, 1)",
                'rgba(84, 202, 82, 1)',
                'rgba(255, 107, 107, 1)',
            ]
        },
        tooltip: {
            y: {
                formatter: function (val) {
                    return val + " units";
                }
            }
        }
    });

    const [statusSeries, setStatusSeries] = useState([
        {
            name: 'Units Sold',
            data: [] // [44, 55, 57, 56, 61, 58, 63, 60, 66, 75, 80, 90]
        },
    ]);

    // New Tab 
    const [condCodeOptions, setCondCodeOptions] = useState({
        chart: {
            type: 'bar',
            height: 350,
            toolbar: {
                show: false // This will hide the toolbar
            }
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '55%',
                endingShape: 'rounded',
                borderRadius: 4,
                borderRadiusApplication: 'end',
                borderRadiusWhenStacked: 'last',
                dataLabels: {
                    position: 'top', // top, center, bottom
                },
            }
        },
        dataLabels: {
            enabled: true,
            offsetY: -20,
            formatter: (val) => {
                return val;
            },
            style: {
                fontSize: '12px',
                colors: ["#304758"]
            }
        },
        stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
        },
        xaxis: {
            categories: ['Servicable', 'Damage',] // ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        },
        yaxis: {
            title: {
                text: "",
                style: {
                    color: '#008FFB',
                }
            },
        },
        fill: {
            opacity: 1,
            colors: [
                "rgba(255, 181, 95, 1)",
                "rgba(203, 140, 255, 1)",
                "rgba(99, 169, 255, 1)",
                'rgba(84, 202, 82, 1)',
                'rgba(255, 107, 107, 1)',
            ]
        },
        tooltip: {
            y: {
                formatter: function (val) {
                    return val + " units";
                }
            }
        }
    });

    const [condCodeSeries, setCondCodeSeries] = useState([
        {
            name: 'ULD',
            data: [] // [44, 55, 57, 56, 61, 58, 63, 60, 66, 75, 80, 90]
        },
    ]);

    const [chartTypeCondOptions, setChartTypeCondOptions] = useState({
        chart: {
            type: 'bar',
            height: 450,
            toolbar: {
                show: false // Hide the toolbar
            }
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '55%',
                endingShape: 'rounded',
                borderRadius: 4,
                borderRadiusApplication: 'end',
                borderRadiusWhenStacked: 'last',
                dataLabels: {
                    position: 'top', // Position data labels in the center of each bar
                },
                distributed: false, // Ensures bars are grouped instead of stacked
            }
        },
        dataLabels: {
            enabled: true,
            offsetY: -20,
            formatter: (val) => val,
            style: {
                fontSize: '13px',
                colors: ["#000"]
            }
        },
        xaxis: {
            categories: [],
            labels: {
                style: {
                    fontSize: '12px',
                    colors: ["#000"],
                    fontWeight: 600,
                }
            }
        },
        yaxis: {
            labels: {
                style: {
                    fontSize: '12px',
                    colors: ["#000"],
                    fontWeight: 600,
                }
            }
        },
        legend: {
            show: true,
            position: 'bottom',
        },
        colors: ['#64c8ff', '#ff4444'], // Different colors for each bar group
        tooltip: {
            shared: true,
            intersect: false,
            y: {
                formatter: function (val) {
                    return val + " units";
                }
            }
        }
    });

    // Initial state for series data
    const [chartTypeCondSeries, setChartTypeCondSeries] = useState([
        {
            name: 'Bar Series',
            type: 'bar',
            data: []
        },
        {
            name: 'Line Series',
            type: 'bar',
            data: []
        }
    ]);

    const [chartStnCondOptions, setChartStnCondOptions] = useState({
        chart: {
            type: 'bar',
            height: 450,
            toolbar: {
                show: false // Hide the toolbar
            }
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '55%',
                endingShape: 'rounded',
                borderRadius: 4,
                borderRadiusApplication: 'end',
                borderRadiusWhenStacked: 'last',
                dataLabels: {
                    position: 'top', // Position data labels in the center of each bar
                },
                distributed: false, // Ensures bars are grouped instead of stacked
            }
        },
        dataLabels: {
            enabled: true,
            offsetY: -20,
            formatter: (val) => val,
            style: {
                fontSize: '13px',
                colors: ["#000"]
            }
        },
        xaxis: {
            categories: [],
            labels: {
                style: {
                    fontSize: '12px',
                    colors: ["#000"],
                    fontWeight: 600,
                }
            }
        },
        yaxis: {
            labels: {
                style: {
                    fontSize: '12px',
                    colors: ["#000"],
                    fontWeight: 600,
                }
            }
        },
        legend: {
            show: true,
            position: 'bottom',
        },
        colors: ['#64c8ff', '#ff4444'], // Different colors for each bar group
        tooltip: {
            shared: true,
            intersect: false,
            y: {
                formatter: function (val) {
                    return val + " units";
                }
            }
        }
    });

    // Initial state for series data
    const [chartStnCondSeries, setChartStnCondSeries] = useState([
        {
            name: 'Bar Series',
            type: 'bar',
            data: []
        },
        {
            name: 'Line Series',
            type: 'bar',
            data: []
        }
    ]);

    const [heatmapTypeOptions, setHeatmapTypeOptions] = useState([]);
    // const [heatmapTypeSeries, setHeatmapTypeSeries] = useState([]);
    const [heatmapOwnerOptions, setHeatmapOwnerOptions] = useState([]);


    const fetchTypeCode = async () => {
        try {
            const res = await withRFSToken.post(GETTYPECODE, {}).then(function (res) {
                const innerData = res.data.response_data;
                const transformedData = innerData
                    ? innerData.map((item) => ({
                        value: item.uld_typecode,
                        label: item.uld_typecode,
                    }))
                    : [];
                setGetTypeCodes(transformedData);
            });
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    const fetchOwnerCode = async () => {
        try {
            const res = await withRFSToken
                .post(GETOWNERCODE, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData
                        ? innerData.map((item) => ({
                            value: item.IATA,
                            label: item.IATA,
                        }))
                        : [];
                    setGetOwnerCode(transformedData);
                    const transformedAirline = innerData
                        ? innerData.map((item) => ({
                            value: item.airline_id,
                            label: item.airline_name,
                        }))
                        : [];
                    setGetAirlineName(transformedAirline);
                });
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    const fetchStation = async () => {
        try {
            const res = await withRFSToken
                .post(GETDESTINATION, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    // console.log('st',innerData);
                    const transformedData = innerData
                        ? innerData.map((item) => ({
                            value: item.port_code,
                            label: item.port_code,
                        }))
                        : [];
                    setGetStation(transformedData);
                });
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    const fetchCondCode = async () => {
        try {

            const res = await withRFSToken.post(GETCONDITIONCODE, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    console.log("🚀 ~ innerData:", innerData)
                    const transformedData = innerData
                        ? Object.entries(innerData).map(([key, value]) => ({
                            value: key,
                            label: value,
                        }))
                        : [];

                    setGetStation(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    // Chart API
    const fetchChartCondCode = async () => {
        try {
            const res = await withRFSToken.post(CHARTCOND, {}).then(function (res) {
                const countData = res.data.response_data.total_ulds;
                setUldCount(countData);
                const innerData = res.data.response_data.condition_codes;
                const condLabel = innerData ? innerData.map((item) => item.condition_code) : [];
                const condData = innerData ? innerData.map((item) => item.count) : [];
                setCondOptions(prevOptions => ({
                    ...prevOptions,
                    xaxis: {
                        ...prevOptions.xaxis,
                        categories: condLabel
                    }
                }));
                setCondCodeOptions(prevOptions => ({
                    ...prevOptions,
                    xaxis: {
                        ...prevOptions.xaxis,
                        categories: condLabel
                    }
                }));
                const condcolors = [
                    "rgba(100, 200, 255, 1)",
                    'rgba(255, 68, 68, 1)',
                    "rgba(203, 203, 203, 1)",
                ];

                const condsData = condData.map((value, index) => ({
                    x: condLabel[index],
                    y: value,
                    fillColor: condcolors[index % condcolors.length]
                }));
                setCondSeries([{
                    name: "ULD's",
                    data: condsData
                }]);
                setCondCodeSeries([{
                    name: "ULD's",
                    data: condsData
                }]);
            });
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const fetchChartTypeCode = async () => {
        try {
            const res = await withRFSToken.post(CHARTYPE, {}).then(function (res) {
                const innerData = res.data.response_data;
                const condLabel = innerData ? innerData.map((item) => item.type_code) : [];
                const condData = innerData ? innerData.map((item) => item.count) : [];
                setChartTypeOptions(prevOptions => ({
                    ...prevOptions,
                    xaxis: {
                        ...prevOptions.xaxis,
                        categories: condLabel
                    }
                }));
                const condcolors = [
                    'rgba(54, 162, 235, 1)',
                ];

                const condsData = condData.map((value, index) => ({
                    x: condLabel[index],
                    y: value,
                    fillColor: condcolors[index % condcolors.length]
                }));
                setChartTypeSeries([{
                    name: "ULD's",
                    data: condsData
                }]);
            });
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const fetchLoanTypeCode = async () => {
        try {
            const res = await withRFSToken.post(CHARTYPE, { tab_name: 'On Loan' }).then(function (res) {
                const innerData = res.data.response_data;
                const filteredData = innerData.filter(item => item.description === 'In Operation' || item.description === 'Repair');
                const condLabel = innerData ? innerData.map((item) => item.type_code) : [];
                const condData = innerData ? innerData.map((item) => item.count) : [];
                setChartLoanTypeOptions(prevOptions => ({
                    ...prevOptions,
                    xaxis: {
                        ...prevOptions.xaxis,
                        categories: condLabel
                    }
                }));
                const condcolors = [
                    'rgba(54, 162, 235, 1)',
                ];

                const condsData = condData.map((value, index) => ({
                    x: condLabel[index],
                    y: value,
                    fillColor: condcolors[index % condcolors.length]
                }));
                setChartLoanTypeSeries([{
                    name: "ULD's",
                    data: condsData
                }]);
            });
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const fetchChartOwnerCode = async () => {
        try {
            const res = await withRFSToken.post(CHARTOWNER, {}).then(function (res) {
                const innerData = res.data.response_data;
                const condLabel = innerData ? innerData.map((item) => item.owner_code) : [];
                const condData = innerData ? innerData.map((item) => item.count) : [];
                setChartOwnerOptions(prevOptions => ({
                    ...prevOptions,
                    xaxis: {
                        ...prevOptions.xaxis,
                        categories: condLabel
                    }
                }));
                const condcolors = [
                    'rgba(54, 162, 235, 1)',
                ];

                const condsData = condData.map((value, index) => ({
                    x: condLabel[index],
                    y: value,
                    fillColor: condcolors[index % condcolors.length]
                }));
                setChartOwnerSeries([{
                    name: "ULD's",
                    data: condsData
                }]);
            });
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const fetchLoanOwnerCode = async () => {
        try {
            const res = await withRFSToken.post(CHARTOWNER, { tab_name: 'On Loan' }).then(function (res) {
                const innerData = res.data.response_data;
                const filteredData = innerData.filter(item => item.description === 'In Operation' || item.description === 'Repair');
                const condLabel = innerData ? innerData.map((item) => item.owner_code) : [];
                const condData = innerData ? innerData.map((item) => item.count) : [];
                setChartLoanOwnerOptions(prevOptions => ({
                    ...prevOptions,
                    xaxis: {
                        ...prevOptions.xaxis,
                        categories: condLabel
                    }
                }));
                const condcolors = [
                    'rgba(54, 162, 235, 1)',
                ];

                const condsData = condData.map((value, index) => ({
                    x: condLabel[index],
                    y: value,
                    fillColor: condcolors[index % condcolors.length]
                }));
                setChartLoanOwnerSeries([{
                    name: "ULD's",
                    data: condsData
                }]);
            });
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const fetchChartStation = async () => {
        try {
            const res = await withRFSToken.post(CHARTSTATION, {}).then(function (res) {
                const innerData = res.data.response_data;
                const condLabel = innerData ? innerData.map((item) => item.uld_station) : [];
                const condData = innerData ? innerData.map((item) => item.count) : [];
                setStationOptions(prevOptions => ({
                    ...prevOptions,
                    xaxis: {
                        ...prevOptions.xaxis,
                        categories: condLabel
                    }
                }));
                const condcolors = [
                    'rgba(54, 162, 235, 1)',
                ];

                const condsData = condData.map((value, index) => ({
                    x: condLabel[index],
                    y: value,
                    fillColor: condcolors[index % condcolors.length]
                }));
                setStationSeries([{
                    name: "ULD's",
                    data: condsData
                }]);
            });
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    const fetchLoanStation = async () => {
        try {
            const res = await withRFSToken.post(CHARTSTATION, { tab_name: 'On Loan' }).then(function (res) {
                const innerData = res.data.response_data;
                const condLabel = innerData ? innerData.map((item) => item.uld_station || 'NSC') : [];
                const condData = innerData ? innerData.map((item) => item.count) : [];
                setLoanStationOptions(prevOptions => ({
                    ...prevOptions,
                    xaxis: {
                        ...prevOptions.xaxis,
                        categories: condLabel
                    }
                }));
                const condcolors = [
                    'rgba(54, 162, 235, 1)',
                ];

                const condsData = condData.map((value, index) => ({
                    x: condLabel[index],
                    y: value,
                    fillColor: condcolors[index % condcolors.length]
                }));
                setLoanStationSeries([{
                    name: "ULD's",
                    data: condsData
                }]);
            });
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    const fetchLoanAgent = async () => {
        try {
            const res = await withRFSToken.post(CHARTLOANAGENTS, {}).then(function (res) {
                const innerData = res.data.response_data;
                const condLabel = innerData ? innerData.map((item) => item.agent_name) : [];
                const condData = innerData ? innerData.map((item) => item.count) : [];
                setLoanAgentOptions(prevOptions => ({
                    ...prevOptions,
                    xaxis: {
                        ...prevOptions.xaxis,
                        categories: condLabel
                    }
                }));
                const condcolors = [
                    'rgba(54, 162, 235, 1)',
                ];

                const condsData = condData.map((value, index) => ({
                    x: condLabel[index],
                    y: value,
                    fillColor: condcolors[index % condcolors.length]
                }));
                setLoanAgentSeries([{
                    name: "ULD's",
                    data: condsData
                }]);
            });
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    const fetchStatus = async () => {
        try {
            const res = await withRFSToken.post(CHARTSTATUS, {}).then(function (res) {
                const innerData = res.data.response_data;
                const filteredData = innerData.filter(item => item.description === 'In Operation' || item.description === 'Repair');
                const condLabel = innerData ? innerData.map((item) => item.uld_status) : [];
                const condData = innerData ? innerData.map((item) => item.count) : [];
                setStatusOptions(prevOptions => ({
                    ...prevOptions,
                    xaxis: {
                        ...prevOptions.xaxis,
                        categories: condLabel
                    }
                }));
                const colors = [
                    "rgba(255, 181, 95, 1)",
                    "rgba(203, 140, 255, 1)",
                    "rgba(99, 169, 255, 1)",
                    'rgba(84, 202, 82, 1)',
                    'rgba(255, 107, 107, 1)',
                ];

                const condsData = condData.map((value, index) => ({
                    x: condLabel[index],
                    y: value,
                    fillColor: colors[index % colors.length]
                }));
                setStatusSeries([{
                    name: "ULD's",
                    data: condsData
                }]);
            });
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const fetchTypeCond = async () => {
        try {
            const res = await withRFSToken.post(CHARTTYPECOND, {}).then(function (res) {
                const innerData = res.data.response_data;

                const categories = innerData.map(item => item.type_code || 'NSC');  // Replace null with 'NTC'
                const serviceableData = innerData.map(item => {
                    const serviceable = item.condition_codes.find(cond => cond.condition_code === "Serviceable");
                    return serviceable ? serviceable.count : 0;
                });
                const damagedData = innerData.map(item => {
                    const damaged = item.condition_codes.find(cond => cond.condition_code === "Damaged");
                    return damaged ? damaged.count : 0;
                });

                // Set the data in state
                setChartTypeCondSeries([
                    {
                        name: 'Serviceable',
                        type: 'bar',
                        data: serviceableData
                    },
                    {
                        name: 'Damaged',
                        type: 'bar',
                        data: damagedData
                    }
                ]);

                setChartTypeCondOptions(prevOptions => ({
                    ...prevOptions,
                    xaxis: {
                        ...prevOptions.xaxis,
                        categories: categories
                    }
                }));

            });
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const fetchSTNCond = async () => {
        try {
            const res = await withRFSToken.post(CHARTSTNCOND, {}).then(function (res) {
                const innerData = res.data.response_data;

                // const categories = [];
                // const serviceableData = [];
                // const damagedData = [];

                // innerData.forEach(item => {
                //     categories.push(item.station);
                //     const serviceable = item.condition_codes.find(cond => cond.condition_code === "Serviceable");
                //     const damaged = item.condition_codes.find(cond => cond.condition_code === "Damaged");

                //     serviceableData.push(serviceable ? serviceable.count : 0);
                //     damagedData.push(damaged ? damaged.count : 0);
                // });

                const categories = innerData.map(item => item.station || 'NSC');  // Replace null with 'NTC'
                const serviceableData = innerData.map(item => {
                    const serviceable = item.condition_codes.find(cond => cond.condition_code === "Serviceable");
                    return serviceable ? serviceable.count : 0;
                });
                const damagedData = innerData.map(item => {
                    const damaged = item.condition_codes.find(cond => cond.condition_code === "Damaged");
                    return damaged ? damaged.count : 0;
                });

                // Set the data in state
                setChartStnCondSeries([
                    {
                        name: 'Serviceable',
                        type: 'bar',
                        data: serviceableData
                    },
                    {
                        name: 'Damaged',
                        type: 'bar',
                        data: damagedData
                    }
                ]);

                setChartStnCondOptions(prevOptions => ({
                    ...prevOptions,
                    xaxis: {
                        ...prevOptions.xaxis,
                        categories: categories
                    }
                }));

            });
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const fetchTable = async (chartFilters) => {
        try {
            const res = await withRFSToken
                .post(CHARTTABLE, { chartFilters })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    setMatrixData(innerData);
                });
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    const fetchOwnerTable = async (chartFilters) => {
        try {
            const res = await withRFSToken.post(CHARTOWNERTABLE, { chartFilters })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    setMatrixOwnerData(innerData);
                });
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    useEffect(() => {
        if (isMounted.current) return;
        fetchChartTypeCode();
        fetchChartOwnerCode();
        fetchChartStation();
        fetchStatus();
        fetchChartCondCode();
        fetchTypeCond();
        fetchSTNCond();
        fetchOwnerTable();
        fetchLoanTypeCode();
        fetchLoanOwnerCode();
        fetchLoanStation();
        fetchLoanAgent();
        fetchTable();
        isMounted.current = true;
    }, []);
    // useEffect(() => {
    //     // fetchChart(formData);
    //     // fetchTable(formData);
    // }, [formData]);
    const handleFormChange = (selectedOption, actionMeta) => {
        const { name } = actionMeta;
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: selectedOption ? selectedOption.value : "",
        }));
    };


    useEffect(() => {
        if (!matrixData || matrixData?.length === 0) return;

        const xAxisLabels = [...new Set(matrixData.map(item => item.typeCode))];
        const yAxisLabels = [...new Set(matrixData.map(item => item.station_code))];

        const data = yAxisLabels.map(station => {
            return {
                name: station,
                data: xAxisLabels.map(typeCode => {
                    const item = matrixData.find(
                        entry => entry.typeCode === typeCode && entry.station_code === station
                    );
                    return item ? parseInt(item.count, 10) : 0;
                }),
            };
        });

        setHeatmapTypeOptions({
            chart: {
                type: 'heatmap',
                height: 450,
                toolbar: {
                    show: false // Hide the toolbar
                }
            },
            plotOptions: {
                heatmap: {
                    shadeIntensity: 0.5,
                    radius: 0,
                    colorScale: {
                        ranges: [
                            { from: 0, to: 199, name: 'Low', color: '#b5dffe' },
                            { from: 199, to: 200, name: 'Medium', color: '#44adfc' },
                            { from: 201, to: 1000, name: 'High', color: '#0893fb' }
                        ],
                    }
                },
            },
            xaxis: {
                categories: xAxisLabels,
                position: 'top',
            },
            yaxis: {
                categories: yAxisLabels,
            },
            dataLabels: {
                enabled: true,
                style: {
                    colors: ['#000']
                },
                formatter: function (val) {
                    return val;
                }
            },
            series: data,
            // title: {
            //     text: 'Station wise ULD type codes'
            // }
        });
    }, [matrixData]); // its for Apex

    useEffect(() => {
        if (!matrixOwnerData || matrixOwnerData?.length === 0) return;

        const xAxisLabels = [...new Set(matrixOwnerData.map(item => item.owner_code))];
        const yAxisLabels = [...new Set(matrixOwnerData.map(item => item.station || 'NSC'))];

        const data = yAxisLabels.map(station => {
            return {
                name: station,
                data: xAxisLabels.map(owner_code => {
                    const item = matrixOwnerData.find(
                        entry => entry.owner_code === owner_code && entry.station === station
                    );
                    return item ? parseInt(item.count, 10) : 0;
                }),
            };
        });

        setHeatmapOwnerOptions({
            chart: {
                type: 'heatmap',
                height: 450,
                toolbar: {
                    show: false // Hide the toolbar
                }
            },
            plotOptions: {
                heatmap: {
                    shadeIntensity: 0.5,
                    radius: 0,
                    colorScale: {
                        ranges: [
                            { from: 0, to: 50, name: 'Low', color: '#b5dffe' },
                            { from: 51, to: 200, name: 'Medium', color: '#44adfc' },
                            { from: 201, to: 1000, name: 'High', color: '#0893fb' },
                        ],
                    }
                },
            },
            xaxis: {
                categories: xAxisLabels,
                position: 'top',
            },
            yaxis: {
                categories: yAxisLabels,
            },
            dataLabels: {
                enabled: true,
                style: {
                    colors: ['#000']
                },
                formatter: function (val) {
                    return val;
                }
            },
            series: data,
            // title: {
            //     text: 'Station wise ULD type codes'
            // }
        });
    }, [matrixOwnerData]);

    // Reusable function to fetch data and update chart
    const fetchAndSetChartData = async (apiEndpoint, formData, loan, setOptions, setSeries) => {
        try {
            const payload = loan ? { tab_name: 'On Loan', chartFilters: formData } : { chartFilters: formData };
            const res = await withRFSToken.post(apiEndpoint, payload);
            let innerData;
            let condLabel;
            let condData;
            if (apiEndpoint === CHARTCOND) {
                const countData = res.data.response_data.total_ulds;
                setUldCount(countData);
                innerData = res.data.response_data.condition_codes;
                condLabel = innerData ? innerData.map((item) => item.condition_code) : [];
                condData = innerData ? innerData.map((item) => item.count) : [];
            } else if (apiEndpoint === CHARTYPE) {
                innerData = res.data.response_data;
                condLabel = innerData ? innerData.map((item) => item.type_code) : [];
                condData = innerData ? innerData.map((item) => item.count) : [];
            } else if (apiEndpoint === CHARTOWNER) {
                innerData = res.data.response_data;
                condLabel = innerData ? innerData.map((item) => item.owner_code) : [];
                condData = innerData ? innerData.map((item) => item.count) : [];
            } else if (apiEndpoint === CHARTSTATION) {
                innerData = res.data.response_data;
                condLabel = innerData ? innerData.map((item) => item.uld_station) : [];
                condData = innerData ? innerData.map((item) => item.count) : [];
            } else if (apiEndpoint === CHARTLOANAGENTS) {
                innerData = res.data.response_data;
                condLabel = innerData ? innerData.map((item) => item.agent_name) : [];
                condData = innerData ? innerData.map((item) => item.count) : [];
            } else if (apiEndpoint === CHARTSTATUS) {
                innerData = res.data.response_data;
                condLabel = innerData ? innerData.map((item) => item.uld_status) : [];
                condData = innerData ? innerData.map((item) => item.count) : [];
            }

            if (apiEndpoint === CHARTTYPECOND || apiEndpoint === CHARTSTNCOND) {
                const innerData = res.data.response_data || [];

                let categories;
                if (apiEndpoint === CHARTTYPECOND) {
                    categories = innerData.map(item => item.type_code || 'NSC');
                } else {
                    categories = innerData.map(item => item.station || 'NSC');
                }
                // const categories = innerData.map(item => item.station || 'NSC');  // Replace null with 'NTC'
                const serviceableData = innerData.map(item => {
                    const serviceable = item.condition_codes.find(cond => cond.condition_code === "Serviceable");
                    return serviceable ? serviceable.count : 0;
                });
                const damagedData = innerData.map(item => {
                    const damaged = item.condition_codes.find(cond => cond.condition_code === "Damaged");
                    return damaged ? damaged.count : 0;
                });

                // Set the data in state
                setSeries([
                    {
                        name: 'Serviceable',
                        type: 'bar',
                        data: serviceableData
                    },
                    {
                        name: 'Damaged',
                        type: 'bar',
                        data: damagedData
                    }
                ]);

                setOptions(prevOptions => ({
                    ...prevOptions,
                    xaxis: {
                        ...prevOptions.xaxis,
                        categories: categories
                    }
                }));
            } else if (apiEndpoint === CHARTTABLE) {
                innerData = res.data.response_data;
                setMatrixData(innerData);
            } else if (apiEndpoint === CHARTOWNERTABLE) {
                innerData = res.data.response_data;
                setMatrixOwnerData(innerData);
            } else {
                let condcolors = [];
                if (apiEndpoint === CHARTCOND) {
                    condcolors = [
                        "rgba(100, 200, 255, 1)",
                        'rgba(255, 68, 68, 1)',
                        "rgba(203, 203, 203, 1)",
                    ];
                } else if (apiEndpoint === CHARTSTATUS) {
                    condcolors = [
                        "rgba(255, 181, 95, 1)",
                        "rgba(203, 140, 255, 1)",
                        "rgba(99, 169, 255, 1)",
                        'rgba(84, 202, 82, 1)',
                        'rgba(255, 107, 107, 1)',
                    ];
                } else {
                    condcolors = [
                        'rgba(54, 162, 235, 1)',
                    ];
                }


                const condsData = condData?.map((value, index) => ({
                    x: condLabel[index],
                    y: value,
                    fillColor: condcolors[index % condcolors?.length]
                }));

                // Update chart options
                if (apiEndpoint === CHARTCOND) {
                    setCondCodeOptions(prevOptions => ({
                        ...prevOptions,
                        xaxis: {
                            ...prevOptions.xaxis,
                            categories: condLabel
                        }
                    }));

                    // Update chart series
                    setCondCodeSeries([{
                        name: "ULD's",
                        data: condsData
                    }]);
                }
                setOptions(prevOptions => ({
                    ...prevOptions,
                    xaxis: {
                        ...prevOptions.xaxis,
                        categories: condLabel
                    }
                }));

                // Update chart series
                setSeries([{
                    name: "ULD's",
                    data: condsData
                }]);
            }


        } catch (error) {
            console.error(`Error fetching data for ${apiEndpoint}:`, error);
        }
    };

    const handleSubmit = async () => {
        // Fetch and update each chart loan
        setIsFilter(true);
        await fetchAndSetChartData(CHARTCOND, formData, '', setCondOptions, setCondSeries);
        await fetchAndSetChartData(CHARTYPE, formData, '', setChartTypeOptions, setChartTypeSeries);
        await fetchAndSetChartData(CHARTYPE, formData, 'loan', setChartLoanTypeOptions, setChartLoanTypeSeries);
        await fetchAndSetChartData(CHARTOWNER, formData, '', setChartOwnerOptions, setChartOwnerSeries);
        await fetchAndSetChartData(CHARTOWNER, formData, 'loan', setChartLoanOwnerOptions, setChartLoanOwnerSeries);
        await fetchAndSetChartData(CHARTSTATION, formData, '', setStationOptions, setStationSeries);
        await fetchAndSetChartData(CHARTSTATION, formData, 'loan', setLoanStationOptions, setLoanStationSeries);
        await fetchAndSetChartData(CHARTLOANAGENTS, formData, '', setLoanAgentOptions, setLoanAgentSeries);
        await fetchAndSetChartData(CHARTSTATUS, formData, '', setStatusOptions, setStatusSeries);
        await fetchAndSetChartData(CHARTTYPECOND, formData, '', setChartTypeCondOptions, setChartTypeCondSeries);
        await fetchAndSetChartData(CHARTSTNCOND, formData, '', setChartStnCondOptions, setChartStnCondSeries);
        await fetchAndSetChartData(CHARTTABLE, formData);
        await fetchAndSetChartData(CHARTOWNERTABLE, formData);
        setSidenavWidth({ width: 0, padding: 0, slide_bg: 0 });
        // Repeat for all 17 charts
        // await fetchAndSetChartData(CHARTCOND17, formData);
    };


    const handleDownloadClick = (event) => {
        // console.log("sda");
        // const selectedOption = event.target.value;
        // let chartElementId = "";

        // if (selectedOption === "1") {
        //     chartElementId = "assetsChart";
        // } else if (selectedOption === "2") {
        //     chartElementId = "stationsChart";
        // } else if (selectedOption === "3") {
        //     chartElementId = "matrixChart";
        // }

        // if (chartElementId) {
        //-----------------old
        // const chartElement = document.getElementById('print_all');
        // if (chartElement) {
        //     html2canvas(chartElement).then((canvas) => {
        //         const imgData = canvas.toDataURL("image/png");
        //         const pdf = new jsPDF({
        //             orientation: "landscape", // 'portrait' or 'landscape'
        //             unit: "mm", // measurement units
        //             format: "a4", // page format
        //         });
        //         const pdfWidth = pdf.internal.pageSize.getWidth();
        //         const pdfHeight = pdf.internal.pageSize.getHeight();
        //         const imgWidth = pdfWidth - 20;
        //         const imgHeight = (canvas.height * imgWidth) / canvas.width;

        //         pdf.addImage(imgData, "JPG", 10, 10, imgWidth, imgHeight);
        //         pdf.save('chart.pdf');
        //     });
        // }
        //--------------old
        // }
        //-----code
        const chartElement = document.getElementById('print_all');
        const originalWidth = chartElement.offsetWidth;
        const originalHeight = chartElement.offsetHeight;

        // Compensate for zoom level
        const scale = window.devicePixelRatio || 1;
        if (chartElement) {
            html2canvas(chartElement, {
                scale: 2, // capture in higher resolution
                width: originalWidth,
                height: originalHeight,
                useCORS: true,
                scrollX: 0,
                scrollY: -window.scrollY, // avoid capturing scrolled area
            }).then((canvas) => {
                const now = new Date();
                const formattedDateTime = `${String(now.getDate()).padStart(2, '0')}-${String(now.getMonth() + 1).padStart(2, '0')}-${now.getFullYear()} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
                const imgData = canvas.toDataURL("image/png");

                const imgWidth = originalWidth;
                const imgHeight = originalHeight;

                // PDF dimensions in pixels
                const pdf = new jsPDF({
                    orientation: imgWidth > imgHeight ? 'l' : 'p',
                    unit: 'px',
                    format: [imgWidth, imgHeight],
                });

                pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
                pdf.save(`chart-${formattedDateTime}-downloaded.pdf`);
            });
        }
        //-----code
    };
    const handleDownloadChart = (id) => {
        let chartElementId = "";

        if (id === "1") {
            chartElementId = "assetsChart";
        } else if (id === "2") {
            chartElementId = "stationsChart";
        } else if (id === "3") {
            chartElementId = "matrixChart";
        }
        if (chartElementId) {
            const chartElement = document.getElementById(chartElementId);
            if (chartElement) {
                html2canvas(chartElement, { scale: 1.5 }).then((canvas) => {
                    const imgData = canvas.toDataURL("image/jpg", .95);
                    const pdf = new jsPDF({
                        orientation: "landscape", // 'portrait' or 'landscape'
                        unit: "mm", // measurement units
                        format: "a4", // page format
                    });
                    const pdfWidth = pdf.internal.pageSize.getWidth();
                    const pdfHeight = pdf.internal.pageSize.getHeight();
                    const imgWidth = pdfWidth - 20;
                    const imgHeight = (canvas.height * imgWidth) / canvas.width;

                    // pdf.addImage(imgData, "JPG", 10, 10, 190, 0);
                    pdf.addImage(imgData, "JPG", 10, 10, imgWidth, imgHeight);
                    pdf.save(`${chartElementId}.pdf`);
                });
            }
        }
    };

    const resetFilter = () => {
        setFormData({
            type_code: [],
            owner_code: [],
            condition_code: [],
            status: [],
            station_code: [],
            airline_id: [],
        });
        fetchChartTypeCode();
        fetchChartOwnerCode();
        fetchChartStation();
        fetchStatus();
        fetchChartCondCode();
        fetchTypeCond();
        fetchSTNCond();
        fetchOwnerTable();
        fetchLoanTypeCode();
        fetchLoanOwnerCode();
        fetchLoanStation();
        fetchLoanAgent();
        fetchTable();

        setIsFilter(false);
    }

    const [sidenavWidth, setSidenavWidth] = useState({ width: 0, padding: 0, slide_bg: 0 });

    const openNav = () => {
        setSidenavWidth({ width: 300, padding: 30 }); // Open the side navigation
        fetchTypeCode();
        fetchOwnerCode();
        fetchStation();
        // fetchCondCode();
    };

    const closeNav = () => {
        setSidenavWidth({ width: 0, padding: 0, slide_bg: 0 }); // Close the side navigation
    };
    const options = [];
    return (
        <>{/* console.log('sichi', chartOptions, chartSeries) */}
            <div className="">
                <Header />
                <div className="page-body-wrapper schedule">
                    <LeftMenu />
                    <div className="main-panel rounded">
                        <div className="mainTab">
                            {/* <TopMenu /> */}
                            <div className="">
                                <div className="allcontent-fl">
                                    <div className='d-flex justify-content-between mb-3'>
                                        <div>
                                            <button className={selectedButton === 'general' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('general')}>
                                                <img src={selectedButton === 'general' ? AssetsIconA : AssetsIcon} /> <span>General</span>
                                            </button>
                                            <button className={selectedButton === 'onloan' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('onloan')}>
                                                <img src={selectedButton === 'onloan' ? OperationIconA : OperationIcon} /> <span>On Loan</span>
                                            </button>
                                            <button className={selectedButton === 'condcode' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('condcode')}>
                                                <img src={selectedButton === 'condcode' ? OnAirIconA : OnAirIcon} /> <span>Condition Code</span>
                                            </button>
                                            <button className={selectedButton === 'typecode' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('typecode')}>
                                                <img src={selectedButton === 'typecode' ? RepairIconA : RepairIcon} /> <span>Type Code</span>
                                            </button>
                                            <button className={selectedButton === 'ownercode' ? 'exportbtn active' : 'exportbtn'} onClick={() => handleButtonClick('ownercode')}>
                                                <img src={selectedButton === 'ownercode' ? OnLoanIconA : OnLoanIcon} /> <span>Owner Code</span>
                                            </button>
                                        </div>

                                        <div className="d-flex">
                                            {isFilter &&
                                                <Button onClick={resetFilter} className="me-2">Reset Filter</Button>
                                            }
                                            <div className="chart_filter me-2"> <img src={Zoom} ></img> </div>
                                            <div className="chart_filter me-2"> <Link to="#" onClick={() => handleDownloadClick()}> <img src={ChartDown} ></img> </Link></div>
                                            <div className="chart_filter"> <Link to="#" onClick={openNav} > <img src={Filter} ></img> </Link> </div>
                                        </div>


                                    </div>
                                    <div className="lcontent mb-4">
                                        {selectedButton === 'general' &&
                                            <>
                                                <Row id="print_all">
                                                    <Col sm='8'>
                                                        <Row>
                                                            <Col sm='6' className="pe-0">
                                                                <div className="cartbox position-relative all_border">
                                                                    <div className="new_chart">
                                                                        <h3>ULD Count</h3>
                                                                        <p>Total Count</p>
                                                                    </div>
                                                                    <div className="uld_img"><img src={Uldbg} ></img></div>
                                                                    <div className="total_uld">
                                                                        {uldCount}
                                                                    </div>

                                                                </div>
                                                                <div className="cartbox mt-2 uld_conditon all_border">
                                                                    <div className="new_chart">
                                                                        <h3>ULD Condition Code</h3>
                                                                        <p>Catagorization of ULD's by Condition Code</p>
                                                                    </div>
                                                                    {/* <Bar data={CondData} options={CondOptions} /> */}
                                                                    <ApexCharts
                                                                        options={condOptions}
                                                                        series={condSeries}
                                                                        type="bar"
                                                                        height={170}
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col sm='6'>
                                                                <div className="cartbox uld_status all_border">
                                                                    <div className="new_chart">
                                                                        <h3>ULD Status</h3>
                                                                        <p>Catagorization of ULD's by status</p>
                                                                    </div>
                                                                    {/* <Bar data={StatusData} options={StatusOptions} /> */}
                                                                    <ApexCharts
                                                                        options={statusOptions}
                                                                        series={statusSeries}
                                                                        type="bar"
                                                                        height={280}
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col sm='12'>
                                                                <div className="cartbox  mt-2 uld_type all_border" >
                                                                    <div className="new_chart">
                                                                        <h3>ULD Type Code</h3>
                                                                        <p>Catagorization of ULD's by Type Code</p>
                                                                    </div>
                                                                    {/* <Bar data={TypeData} options={TypeOptions} width={1400} height={250} /> */}
                                                                    <ApexCharts
                                                                        options={chartTypeOptions}
                                                                        series={chartTypeSeries}
                                                                        type="bar"
                                                                        height={370}
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col sm='12'>
                                                                <div className="cartbox  mt-2 uld_type all_border">
                                                                    <div className="new_chart">
                                                                        <h3>ULD Owner Code</h3>
                                                                        <p>Catagorization of ULD's by Owner Code</p>
                                                                    </div>
                                                                    {/* <Bar data={TypeData} options={TypeOptions} /> */}
                                                                    <ApexCharts
                                                                        options={chartOwnerOptions}
                                                                        series={chartOwnerSeries}
                                                                        type="bar"
                                                                        height={370}
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                    <Col sm='4' className="ps-0">
                                                        <div className="cartbox h-100 all_border">
                                                            <div className="new_chart">
                                                                <h3>ULD Stations</h3>
                                                                <p>Catagorization of ULD's by Current Station</p>
                                                            </div>
                                                            {/* <Bar data={StationData} options={StationOptions} /> */}
                                                            <ApexCharts
                                                                options={stationOptions}
                                                                series={stationSeries}
                                                                type="bar"
                                                                // height={500}
                                                                height="95%"
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </>
                                        }
                                        {selectedButton === 'onloan' &&
                                            <>
                                                <Row id="print_all">
                                                    <Col sm='8'>
                                                        <Row>
                                                            <Col sm='12'>
                                                                <div className="cartbox uld_type all_border" >
                                                                    <div className="new_chart">
                                                                        <h3>ULD's On Loan by Type Code</h3>
                                                                        <p>Catagorization of On Loan ULD's by Type Code</p>
                                                                    </div>
                                                                    {/* <Bar data={TypeData} options={TypeOptions} width={1400} height={250} /> */}
                                                                    <ApexCharts
                                                                        options={chartLoanTypeOptions}
                                                                        series={chartLoanTypeSeries}
                                                                        type="bar"
                                                                        height={340}
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col sm='12'>
                                                                <div className="cartbox  mt-2 uld_type all_border" >
                                                                    <div className="new_chart">
                                                                        <h3>ULD's On Loan by Owner Code</h3>
                                                                        <p>Catagorization of On Loan ULD's by Owner Code</p>
                                                                    </div>
                                                                    {/* <Bar data={TypeData} options={TypeOptions} width={1400} height={250} /> */}
                                                                    <ApexCharts
                                                                        options={chartLoanOwnerOptions}
                                                                        series={chartLoanOwnerSeries}
                                                                        type="bar"
                                                                        height={340}
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col sm='12'>
                                                                <div className="cartbox  mt-2 uld_type all_border">
                                                                    <div className="new_chart">
                                                                        <h3>ULD's On Loan by Station</h3>
                                                                        <p>Catagorization of On Loan ULD's by Station</p>
                                                                    </div>
                                                                    {/* <Bar data={TypeData} options={TypeOptions} /> */}
                                                                    <ApexCharts
                                                                        options={loanStationOptions}
                                                                        series={loanStationSeries}
                                                                        type="bar"
                                                                        height={340}
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                    <Col sm='4' className="ps-0">
                                                        <div className="cartbox h-100 all_border">
                                                            <div className="new_chart">
                                                                <h3>ULD's On Loan by Agent</h3>
                                                                <p>Catagorization of On Loan ULD's by Agent</p>
                                                            </div>
                                                            {/* <Bar data={StationData} options={StationOptions} /> */}
                                                            <ApexCharts
                                                                options={loanAgentOptions}
                                                                series={loanAgentSeries}
                                                                type="bar"
                                                                // height={500}
                                                                height="95%"
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </>
                                        }
                                        {selectedButton === 'condcode' &&
                                            <>
                                                <Row id="print_all">
                                                    <Col sm='12'>
                                                        <Row>
                                                            <Col sm='3' className="pe-0">
                                                                <div className="cartbox uld_status all_border">
                                                                    <div className="new_chart">
                                                                        <h3>ULD Condition Code</h3>
                                                                        <p>Catagorization of ULD's by Condition Code</p>
                                                                    </div>
                                                                    {/* <Bar data={CondData} options={CondOptions} /> */}
                                                                    <ApexCharts
                                                                        options={condCodeOptions}
                                                                        series={condCodeSeries}
                                                                        type="bar"
                                                                        height={350}
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col sm='9'>
                                                                <div className="cartbox uld_status all_border">
                                                                    <div className="new_chart">
                                                                        <h3>ULD Type Code x Condition Code</h3>
                                                                        <p>Catagorization of ULD's by Type Code and Condition Code</p>
                                                                    </div>
                                                                    {/* <Bar data={StatusData} options={StatusOptions} /> */}
                                                                    <ApexCharts
                                                                        options={chartTypeCondOptions}
                                                                        series={chartTypeCondSeries}
                                                                        type="bar"
                                                                        height={350}
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col sm='12'>
                                                                <div className="cartbox  mt-2 uld_type all_border">
                                                                    <div className="new_chart">
                                                                        <h3>ULD Stations x Condition Code</h3>
                                                                        <p>Catagorization of ULD's by Current Station and Condition Code</p>
                                                                    </div>
                                                                    {/* <Bar data={TypeData} options={TypeOptions} /> */}
                                                                    <ApexCharts
                                                                        options={chartStnCondOptions}
                                                                        series={chartStnCondSeries}
                                                                        type="bar"
                                                                        height={370}
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </>
                                        }
                                        {selectedButton === 'typecode' &&
                                            <>
                                                <div id="print_all" className="cartbox  mt-2 uld_type all_border">
                                                    <div className="new_chart">
                                                        <h3>Station wise ULD type code</h3>

                                                    </div>
                                                    {heatmapTypeOptions && heatmapTypeOptions.series ? (
                                                        <ApexCharts
                                                            options={heatmapTypeOptions}
                                                            series={heatmapTypeOptions.series}
                                                            type="heatmap"
                                                            height={750}
                                                        />
                                                    ) : (<></>)}
                                                </div>
                                            </>
                                        }
                                        {selectedButton === 'ownercode' &&
                                            <>
                                                <div id="print_all" className="cartbox  mt-2 uld_type all_border">
                                                    <div className="new_chart">
                                                        <h3>Station wise ULD Owner code</h3>

                                                    </div>
                                                    {heatmapOwnerOptions && heatmapOwnerOptions.series ? (
                                                        <ApexCharts
                                                            options={heatmapOwnerOptions}
                                                            series={heatmapOwnerOptions.series}
                                                            type="heatmap"
                                                            height={750}
                                                        />
                                                    ) : (
                                                        <></>
                                                    )
                                                    }

                                                </div>
                                            </>
                                        }
                                        <div className="slide_bg" style={{ width: sidenavWidth.slide_bg, }}>
                                            {/* Side Navigation */}
                                            <div id="mySidenav" className="sidenav" style={{ width: sidenavWidth.width, padding: sidenavWidth.padding }}>
                                                <a href="javascript:void(0)" className="closebtn" onClick={closeNav}>
                                                    &times;
                                                </a>
                                                <div className="rafilter">
                                                    <h3>Filter Properties</h3>
                                                    <p>Select Properties that you want to see inside the chart</p>
                                                </div>
                                                <div className="rasl_box">
                                                    <label>Status</label>
                                                    <Select
                                                        options={statusDropOptions}
                                                        onChange={(selected) => {
                                                            const selectedValues = selected ? selected.map(option => option.value) : [];
                                                            setFormData({ ...formData, status: selectedValues });
                                                            // setDownloadData({ ...downloadData, status: selected.value });
                                                        }}
                                                        placeholder="Status"
                                                        className="autoslct"
                                                        name="Status"
                                                        isMulti
                                                        value={statusDropOptions.filter(option => formData.status.includes(option.value))}
                                                    />
                                                </div>
                                                <div className="rasl_box">
                                                    <label>Station</label>
                                                    <Select
                                                        options={getStation}
                                                        // onChange={handleFormChange}
                                                        onChange={(selected) => {
                                                            const selectedValues = selected ? selected.map(option => option.value) : [];
                                                            setFormData({ ...formData, station_code: selectedValues });
                                                            // setDownloadData({ ...downloadData, status: selected.value });
                                                        }}
                                                        placeholder="Station"
                                                        className="autoslct"
                                                        name="station_code"
                                                        isMulti
                                                        value={getStation.filter(option => formData.station_code.includes(option.value))}
                                                    />
                                                </div>
                                                <div className="rasl_box">
                                                    <label>Type Code</label>
                                                    <Select
                                                        options={getTypeCodes}
                                                        // onChange={handleFormChange}
                                                        onChange={(selected) => {
                                                            const selectedValues = selected ? selected.map(option => option.value) : [];
                                                            setFormData({ ...formData, type_code: selectedValues });
                                                            // setDownloadData({ ...downloadData, status: selected.value });
                                                        }}
                                                        placeholder="Type Code"
                                                        className="autoslct"
                                                        name="type_code"
                                                        isMulti
                                                        value={getTypeCodes.filter(option => formData.type_code.includes(option.value))}
                                                    />
                                                </div>
                                                <div className="rasl_box">
                                                    <label>Owner Code</label>
                                                    <Select
                                                        options={getOwnerCodes}
                                                        // onChange={handleFormChange}
                                                        onChange={(selected) => {
                                                            const selectedValues = selected ? selected.map(option => option.value) : [];
                                                            setFormData({ ...formData, owner_code: selectedValues });
                                                            // setDownloadData({ ...downloadData, status: selected.value });
                                                        }}
                                                        placeholder="Owner Code"
                                                        className="autoslct"
                                                        name="owner_code"
                                                        isMulti
                                                        value={getOwnerCodes.filter(option => formData.owner_code.includes(option.value))}
                                                    />
                                                </div>
                                                <div className="rasl_box">
                                                    <label>Condition Code</label>
                                                    <Select
                                                        options={conDropOPtions}
                                                        // onChange={handleFormChange}
                                                        onChange={(selected) => {
                                                            const selectedValues = selected ? selected.map(option => option.value) : [];
                                                            setFormData({ ...formData, condition_code: selectedValues });
                                                            // setDownloadData({ ...downloadData, status: selected.value });
                                                        }}
                                                        placeholder="Condition Code"
                                                        className="autoslct"
                                                        name="condition_code"
                                                        isMulti
                                                        value={conDropOPtions.filter(option => formData.condition_code.includes(option.value))}
                                                    />
                                                    {/* <Form.Select
                                                        aria-label="Default"
                                                    // value={section.condition_code} // == 'Damaged' ? 'DAM' : (section.condition_code == 'Discarded' ? 'DIS' : 'SER')
                                                    // onChange={(e) => handleDetailsChange(section.uld_number, 'condition_code', e.target.value)}
                                                    >
                                                        {getCondCodes &&
                                                            Object.entries(getCondCodes).map((option, index) =>
                                                                <option key={index} value={option[0]}>{option[1]}</option>
                                                            )
                                                        }
                                                    </Form.Select> */}
                                                </div>
                                                <div className='text-center filter_update'>
                                                    <Button variant="light" className='stk_cancel' onClick={closeNav}>CANCEL</Button>
                                                    <Button variant="primary" className='stk_save posr' onClick={handleSubmit}>UPDATE</Button>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
};

export default Charts;
